import React, { useState } from 'react';
import { FiAlertTriangle, FiSettings, FiUsers } from 'react-icons/fi';
import ModalTomadores from './ModalTomadores';
import ModalServicoTomador from './ModalServicoTomador';
import { calcularVencimento } from './cobranca';
import { formatarDocumento } from '../../../utils/documento';
import styles from './Emitir.module.css';

/* Etapa 1 — Pessoas (espelha a primeira aba do Portal Nacional):
   informações gerais, emitente, compras governamentais, tomador,
   destinatário e intermediário. */

/* o que a DPS exige do prestador -- sem isso a Receita recusa, então é
   melhor avisar aqui do que deixar descobrir no erro da transmissão */
export function pendenciasDoEmitente(prestador) {
  const faltando = [];
  if (!prestador?.cnpj && !prestador?.cpf) faltando.push('CNPJ/CPF');
  if (!prestador?.nfCodigoMunicipioEmissor) faltando.push('município do emissor');
  if (!prestador?.nome && !prestador?.empresa) faltando.push('razão social');
  return faltando;
}

function EtapaPessoas({ prestador, dados, set, certificadoConfigurado, onCorrigirCadastro }) {
  const [modalAberto, setModalAberto] = useState(false);
  const [escolhendoServico, setEscolhendoServico] = useState(null); // tomador com 2+ serviços

  /* serviços que valem (com descrição ou valor), valor final calculado */
  const servicosValidos = (t) => (t.servicos || [])
    .map(s => {
      const u = s.valorUnitario === '' || s.valorUnitario == null ? null : Number(s.valorUnitario);
      const q = Number(s.quantidade);
      const valor = u === null ? s.valor : Math.round(u * (q > 0 ? q : 1) * 100) / 100;
      return { ...s, valor };
    })
    .filter(s => String(s.descricao || '').trim() || (s.valor !== '' && s.valor != null));
  const aplicarServico = (s) => {
    /* serviço cobrado por quantidade: a emissão mostra unitário × quantidade */
    set('usaQuantidade', !!s.informarQuantidade);
    set('valorUnitario', s.informarQuantidade ? String(s.valor ?? '') : '');
    if (s.valor !== '' && s.valor != null) { set('quantidade', ''); set('valorServico', String(s.valor)); }
    if (String(s.descricao || '').trim()) set('descricaoServico', s.descricao.trim());
  };

  const pendencias = pendenciasDoEmitente(prestador);




  return (
    <div className={styles.etapa}>
      {/* Emitente não aparece em campos: o cliente já foi escolhido e repetir
          os dados dele só ocupa espaço. Só fala algo quando FALTA algo --
          e aí com um botão pra corrigir sem sair da emissão. */}
      {(pendencias.length > 0 || !certificadoConfigurado) && (
        <div className={styles.aviso}>
          <FiAlertTriangle size={14} />
          <div style={{ flex: 1 }}>
            {pendencias.length > 0 && (
              <div>Faltam dados no cadastro de <strong>{prestador.empresa || prestador.nome}</strong>: {pendencias.join(', ')}.</div>
            )}
            {!certificadoConfigurado && (
              <div>Sem certificado A1 válido em <strong>Clientes › Certificados</strong> (ausente, vencido ou senha errada) — sem ele a nota não pode ser assinada.</div>
            )}
            <button type="button" className={styles.btnCorrigir} onClick={onCorrigirCadastro}>
              <FiSettings size={12} /> Corrigir agora
            </button>
          </div>
        </div>
      )}

      {/* ───────── Tomador ─────────
          Só 2 campos em leitura: cadastro e consulta vivem no modal, pra
          emissão não virar um formulário gigante. */}
      <section className={styles.secao}>
        {/* botão antes do título e só com ícone: o próprio título já diz do
            que se trata, então o texto no botão era redundante */}
        <div className={styles.tomadorCabecalho}>
          <button type="button" className={styles.btnSelecionarIcone}
            onClick={() => setModalAberto(true)}
            title={dados.tomadorDocumento ? 'Trocar tomador' : 'Selecionar tomador'}>
            <FiUsers size={14} />
          </button>
          <h3 className={styles.secaoTitulo} style={{ margin: 0 }}>Tomador do serviço</h3>
        </div>

        {dados.tomadorDocumento ? (
          <div className={styles.grade}>
            <div className={styles.campo}>
              <span className={styles.rotulo}>CPF/CNPJ</span>
              <div className={styles.valorFixo}>{formatarDocumento(dados.tomadorDocumento)}</div>
            </div>
            <div className={styles.campo}>
              <span className={styles.rotulo}>Nome / Razão social</span>
              <div className={styles.valorFixo}>{dados.tomadorNome || '—'}</div>
            </div>
          </div>
        ) : (
          <p className={styles.explicacao} style={{ margin: 0 }}>
            Nenhum tomador selecionado. Use o botão ao lado do título para escolher ou cadastrar.
          </p>
        )}
      </section>

      {modalAberto && (
        <ModalTomadores
          clienteId={prestador.id}
          onFechar={() => setModalAberto(false)}
          onSelecionar={(t) => {
            set('tomadorDocumento', t.documento || '');
            set('tomadorNome', t.nome || '');
            set('tomadorEmail', t.email || '');
            set('tomadorTelefone', t.telefone || '');
            set('tomadorCep', t.cep || '');
            set('tomadorCodigoMunicipio', t.codigoMunicipio || t.codigo_municipio || '');
            set('tomadorLogradouro', t.logradouro || '');
            set('tomadorNumero', t.numero || '');
            set('tomadorComplemento', t.complemento || '');
            set('tomadorBairro', t.bairro || '');
            /* cobrança padrão do tomador: só preenche o que ele tem; tudo segue editável */
            const servicos = servicosValidos(t);
            if (servicos.length > 1) setEscolhendoServico({ tomador: t, servicos });
            else if (servicos.length === 1) aplicarServico(servicos[0]);
            else {
              if (t.valorServico !== '' && t.valorServico != null) set('valorServico', String(t.valorServico));
              if (t.descricaoServico) set('descricaoServico', t.descricaoServico);
            }
            set('vencimentoInformar', t.vencimentoTipo === 'informar');
            if (t.vencimentoTipo) set('vencimento', calcularVencimento(t.vencimentoTipo, t.vencimentoValor, dados.competencia || new Date().toISOString().slice(0, 10)));
            if (Array.isArray(t.adicionais)) set('adicionais', t.adicionais.map(a => ({ rotulo: a.rotulo || '', valor: a.valor ?? '' })));
            setModalAberto(false);
          }}
        />
      )}

      {escolhendoServico && (
        <ModalServicoTomador tomador={escolhendoServico.tomador} servicos={escolhendoServico.servicos}
          onEscolher={(s) => { aplicarServico(s); setEscolhendoServico(null); }}
          onFechar={() => setEscolhendoServico(null)} />
      )}
    </div>
  );
}

export default EtapaPessoas;
